export default "__VITE_ASSET__BBVFB2dB__"